/**
 * Register service worker and subscribe to Web Push (requires VAPID public key in meta tag).
 */
function readMeta(name) {
    const el = document.querySelector(`meta[name="${name}"]`);
    return el ? el.getAttribute('content') : '';
}

function csrfToken() {
    return readMeta('csrf-token');
}

export async function trySubscribeWebPush() {
    const vapidPublic = readMeta('webpush-vapid-public');
    const subscribeUrl = readMeta('webpush-subscribe-url');
    if (!vapidPublic || !subscribeUrl || !('serviceWorker' in navigator) || !('PushManager' in window)) {
        return { ok: false, reason: 'unsupported_or_unconfigured' };
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
        return { ok: false, reason: 'permission_denied' };
    }

    const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
    await navigator.serviceWorker.ready;

    const applicationServerKey = urlBase64ToUint8Array(vapidPublic);
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey,
        });
    }

    const subJson = subscription.toJSON();
    const encodings = typeof PushManager !== 'undefined' && PushManager.supportedContentEncodings
        ? PushManager.supportedContentEncodings
        : ['aesgcm'];
    const res = await fetch(subscribeUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-TOKEN': csrfToken(),
            'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
            endpoint: subJson.endpoint,
            keys: subJson.keys,
            contentEncoding: encodings[0] || 'aesgcm',
        }),
    });

    if (!res.ok) {
        const text = await res.text();
        return { ok: false, reason: 'server_error', status: res.status, text };
    }

    return { ok: true };
}

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
